var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8901 21.2073C20.8901 24.5412 18.1397 27.2483 14.7324 27.2483C11.3251 27.2483 8.57471 24.5412 8.57471 21.2073C8.57471 17.8734 11.3251 15.1663 14.7324 15.1663C18.1397 15.1663 20.8901 17.8734 20.8901 21.2073ZM27.6362 21.2073C27.6362 24.3412 26.2542 26.8883 24.5574 26.8883C22.8606 26.8883 21.4785 24.3412 21.4785 21.2073C21.4785 18.0734 22.8606 15.5263 24.5574 15.5263C26.2542 15.5263 27.6362 18.0601 27.6362 21.2073ZM30.4004 21.2073C30.4004 24.0211 29.9214 26.3015 29.3193 26.3015C28.7172 26.3015 28.2383 24.0211 28.2383 21.2073C28.2383 18.3935 28.7172 16.1131 29.3193 16.1131C29.9214 16.1131 30.4004 18.3935 30.4004 21.2073Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.9cf34d20629a1bd076ec67f3e8b248c8.svg";
export { ForwardRef as ReactComponent };